// Reads Vite-style env vars without referencing `import.meta` directly.
//
// Why: `import.meta` is ESM-only syntax. If it appears literally in
// libs/core's CJS-compiled dist .js files, Node 22's auto-detect-module
// (enabled by default) treats those files as ESM and the CJS exports
// blow up with `ReferenceError: exports is not defined in ES module scope`.
//
// Solution: web-side bootstrap copies `import.meta.env` into
// `globalThis.__VITE_ENV__` (and `import.meta.hot` into `__VITE_HOT__`)
// at app startup. libs/core reads those globals — works in browser/Vite
// and is undefined-safe on the server.

declare global {
	// eslint-disable-next-line no-var
	var __VITE_ENV__: Record<string, string | undefined> | undefined;
	// eslint-disable-next-line no-var
	var __VITE_HOT__: unknown | undefined;
}

export function getViteEnv(key: string): string | undefined {
	return globalThis.__VITE_ENV__?.[key];
}

export function isViteHot(): boolean {
	return globalThis.__VITE_HOT__ != null;
}
